(ns entities.insurance.specs
  (:require
    [cljs.spec.alpha :as s]
    )
  )

;; @TODO this should be a more precise date spec
(s/def ::date string?)

(s/def ::amount number?)
(s/def ::beneficiaries (s/nilable string?))
(s/def ::carrier string?)
(s/def ::exp-date ::date)
(s/def ::id string?)
(s/def ::issue-date ::date)
(s/def ::policy-type string?)
(s/def ::premium-amount number?)
(s/def ::premium-due-date (s/nilable ::date))

(s/def ::policy (s/nilable (s/keys :req-un [
                                            ::amount
                                            ::beneficiaries
                                            ::carrier
                                            ::exp-date
                                            ::id
                                            ::issue-date
                                            ::policy-type
                                            ::premium-amount
                                            ::premium-due-date
                                            ])))

(s/def ::insurance (s/coll-of ::policy))
